import DefaultApiService from "./default.js";

const unwrap = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (!isSuccess) {
    return {
      error: res?.message || res?.Message || fallbackMessage,
      data: null,
    };
  }
  return { error: null, data: res?.data ?? res?.Data ?? null };
};

const ContractorReferralPortalApi = {
  getReferral: () => DefaultApiService.getApi("SLN/Contractor/ContractorReferral/GetReferral"),

  getAttributions: (params) =>
    DefaultApiService.getApi("SLN/Contractor/ContractorReferral/GetAttributions", params),

  getAttributionTracking: (attributionId) =>
    DefaultApiService.getApi("SLN/Contractor/ContractorReferral/GetAttributionTracking", {
      attributionId,
    }),

  normalizeAttributions: (res) =>
    unwrap(res, "بارگذاری گزارش معرفی‌ها ناموفق بود."),

  normalizeTracking: (res) =>
    unwrap(res, "بارگذاری تاریخچه مراحل ناموفق بود."),
};

export default ContractorReferralPortalApi;
